var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mx-1",attrs:{"title":_vm.$t('global.info.field_translatable')}},[_c('font-awesome-icon',{staticClass:"text-black-50",attrs:{"icon":['fal', _vm.icons.info.translation],"size":"sm"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }